import { ContributionStore, ContributionStoreProps } from "@ctypes";
import { create } from "zustand";

export const useContributionStore = create<ContributionStore>((set) => ({
  contributionProps: {},
  setContributionProps: (contributionProps: ContributionStoreProps) =>
    set(() => ({ contributionProps })),
}));
